import { render, staticRenderFns } from "./TreeGrupo.vue?vue&type=template&id=b2b6a976&scoped=true&"
import script from "./TreeGrupo.vue?vue&type=script&lang=js&"
export * from "./TreeGrupo.vue?vue&type=script&lang=js&"
import style0 from "./TreeGrupo.vue?vue&type=style&index=0&id=b2b6a976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b6a976",
  null
  
)

export default component.exports